import React, { useEffect, useState } from 'react'
import { Table, Button, Typography, Tag, message, Alert, Input } from 'antd'
import { WhatsAppOutlined, SearchOutlined } from '@ant-design/icons'
import { clientsAPI, whatsappAPI } from '../services/api'

const { Title, Text } = Typography

const buildMessage = (c) => {
  return `Hola ${c.name}, te paso tus datos para entrar al portal de Espiritu Libre:\n\nUsuario: ${c.name} ${c.lastName}\nContrasena: ${c.personalCode}\n\nEntra aca: https://espiritulibre.site/portal`
}

const waLink = (c) => {
  let phone = (c.phone || '').replace(/\D/g, '')
  if (!phone.startsWith('54')) phone = '54' + phone
  return `https://wa.me/${phone}?text=${encodeURIComponent(buildMessage(c))}`
}

function Usuarios() {
  const [clients, setClients] = useState([])
  const [filtered, setFiltered] = useState([])
  const [loading, setLoading] = useState(false)
  const [sendingId, setSendingId] = useState(null)
  const [waStatus, setWaStatus] = useState('unknown')
  const [search, setSearch] = useState('')

  useEffect(() => {
    load()
    whatsappAPI.getStatus().then(r => setWaStatus(r.data?.status || 'unknown')).catch(() => {})
  }, [])

  useEffect(() => {
    if (!search.trim()) { setFiltered(clients); return }
    const q = search.toLowerCase()
    setFiltered(clients.filter(c =>
      `${c.name} ${c.lastName}`.toLowerCase().includes(q) ||
      c.personalCode?.includes(q) ||
      c.phone?.includes(q)
    ))
  }, [search, clients])

  const load = async () => {
    setLoading(true)
    try {
      const res = await clientsAPI.getAll()
      setClients(res.data)
    } catch (e) { message.error('Error cargando alumnas') }
    finally { setLoading(false) }
  }

  const handleSend = async (c) => {
    setSendingId(c.id)
    try {
      if (waStatus === 'connected') {
        await whatsappAPI.sendTest(c.phone, buildMessage(c))
        message.success('Mensaje enviado por WhatsApp a ' + c.name)
      } else {
        window.open(waLink(c), '_blank')
      }
    } catch (e) {
      window.open(waLink(c), '_blank')
      if (e.response?.data?.error) message.warning(e.response.data.error)
    } finally { setSendingId(null) }
  }

  const columns = [
    { title: 'Usuario', render: (_, r) => <Text strong>{r.name} {r.lastName}</Text> },
    { title: 'Contraseña', render: (_, r) => r.personalCode
      ? <Tag style={{ fontFamily: 'monospace', letterSpacing: 3, fontSize: 13, padding: '2px 12px', borderRadius: 8 }}>{r.personalCode}</Tag>
      : <Text style={{ color: '#555' }}>—</Text>
    },
    { title: 'Teléfono', render: (_, r) => r.phone || <Text style={{ color: '#555' }}>—</Text> },
    { title: '', key: 'wa', width: 110, render: (_, r) => (
      <Button
        icon={<WhatsAppOutlined />}
        loading={sendingId === r.id}
        onClick={() => handleSend(r)}
        style={{ background: '#25d366', borderColor: '#25d366', color: '#ffffff', borderRadius: 8 }}
      >
        Enviar
      </Button>
    )}
  ]

  return (
    <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
      <Title level={4} style={{ margin: 0, marginBottom: 12 }}>Usuarios y Contraseñas</Title>

      <Alert
        type={waStatus === 'connected' ? 'success' : 'warning'}
        showIcon
        message={
          waStatus === 'connected'
            ? 'WhatsApp conectado. Los mensajes se envían automáticamente a las alumnas.'
            : 'WhatsApp no está conectado. Los botones Enviar abren el chat con la alumna con el mensaje ya escrito.'
        }
        style={{ marginBottom: 12, borderRadius: 10 }}
      />

      <Input
        placeholder="Buscar alumna por nombre o código..."
        prefix={<SearchOutlined />}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        allowClear
        style={{ marginBottom: 12 }}
      />

      <Table
        dataSource={filtered}
        columns={columns}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{ x: 480 }}
        pagination={{ pageSize: 10, size: 'small' }}
        locale={{ emptyText: 'Sin alumnas registradas' }}
      />
    </div>
  )
}

export default Usuarios
